/**
 * DezLin Cart Drawer JS — 2026-05-05
 * 1. Cart accordion panels (Note / Discount / Shipping) — replaces <details>/<summary>
 *    to avoid CartDrawer.onSummaryClick interference that freezes the drawer.
 * 2. Discount code apply (fetch /discount/CODE → reload)
 * 3. Shipping policy popup (intercept .tax-note links → modal)
 */

// ── Cart accordion panels ─────────────────────────────────────
(function () {
  function closeAll() {
    document.querySelectorAll('.dz-accordion').forEach(function (acc) {
      var panel  = acc.querySelector('.dz-accordion-panel');
      var toggle = acc.querySelector('.dz-accordion-toggle');
      if (panel)  panel.setAttribute('hidden', '');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      acc.classList.remove('dz-accordion--open');
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.dz-accordion-toggle');
    if (!toggle) return;
    e.stopPropagation();

    var accordion = toggle.closest('.dz-accordion');
    if (!accordion) return;
    var panel  = accordion.querySelector('.dz-accordion-panel');
    var isOpen = panel && !panel.hasAttribute('hidden');

    closeAll();

    if (!isOpen && panel) {
      panel.removeAttribute('hidden');
      toggle.setAttribute('aria-expanded', 'true');
      accordion.classList.add('dz-accordion--open');
    }
  });

  document.addEventListener('cartdrawer:closed', closeAll);

  // Prevent Enter key in discount input from submitting the cart form
  document.addEventListener('keydown', function (e) {
    if (e.target.id === 'DzDiscountCode' && e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      dzApplyDiscount();
    }
  });
})();

// ── Discount code ────────────────────────────────────────────
function dzApplyDiscount() {
  const input = document.getElementById('DzDiscountCode');
  const msg   = document.getElementById('dz-discount-msg');
  if (!input || !msg) return;

  const code = input.value.trim();
  if (!code) return;

  msg.removeAttribute('hidden');
  msg.className = 'dz-discount-msg';
  msg.textContent = 'Applying...';

  // Shopify validates the code at checkout. We apply it to the session here
  // and reload so the cart re-renders showing any active discount line.
  fetch('/discount/' + encodeURIComponent(code), {
    method: 'GET',
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  })
    .then(() => {
      msg.textContent = 'Saved — applies at checkout if valid. Refreshing...';
      msg.classList.add('dz-discount-msg--ok');
      setTimeout(() => { window.location.reload(); }, 800);
    })
    .catch(() => {
      msg.textContent = 'Something went wrong. Please try again.';
      msg.classList.add('dz-discount-msg--err');
    });
}

// ── Discount removal ─────────────────────────────────────────
// Shopify clears the session discount when the browser navigates to /discount/ with no code.
function dzRemoveDiscount() {
  window.location.href = '/discount/?redirect=%2Fcart';
}

// ── Cart note ─────────────────────────────────────────────────
function dzApplyNote(btn) {
  const accordion = btn.closest('.dz-accordion');
  const textarea  = accordion ? accordion.querySelector('textarea') : null;
  const msg       = document.getElementById('dz-note-msg');

  if (!textarea) {
    if (accordion) accordion.querySelector('.dz-accordion-toggle').click();
    return;
  }

  if (msg) {
    msg.removeAttribute('hidden');
    msg.className = 'dz-note-msg dz-discount-msg';
    msg.textContent = 'Saving…';
  }

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ note: textarea.value })
  })
    .then(r => r.json())
    .then(() => {
      if (msg) {
        msg.textContent = 'Note saved to your order.';
        msg.classList.add('dz-discount-msg--ok');
      }
      setTimeout(() => {
        if (accordion) accordion.querySelector('.dz-accordion-toggle').click();
      }, 1400);
    })
    .catch(() => {
      if (msg) {
        msg.textContent = 'Couldn’t save note. Please try again.';
        msg.classList.add('dz-discount-msg--err');
      }
    });
}

// ── Shipping policy popup ────────────────────────────────────
(function () {
  function buildModal(html) {
    const overlay = document.createElement('div');
    overlay.id = 'dz-policy-overlay';
    overlay.style.cssText = [
      'position:fixed', 'inset:0', 'z-index:9999',
      'background:rgba(17,60,80,0.55)',
      'display:flex', 'align-items:center', 'justify-content:center',
      'padding:20px', 'box-sizing:border-box'
    ].join(';');

    const panel = document.createElement('div');
    panel.style.cssText = [
      'background:#fff', 'border-radius:10px',
      'max-width:520px', 'width:100%',
      'max-height:80vh', 'overflow-y:auto',
      'padding:28px 24px', 'position:relative',
      'font-family:"Plus Jakarta Sans",system-ui,sans-serif',
      'font-size:14px', 'color:#113C50', 'line-height:1.6'
    ].join(';');

    const close = document.createElement('button');
    close.type = 'button';
    close.innerHTML = '&times;';
    close.style.cssText = [
      'position:absolute', 'top:14px', 'right:16px',
      'background:none', 'border:none',
      'font-size:24px', 'line-height:1', 'cursor:pointer',
      'color:#8fa6b4', 'padding:4px'
    ].join(';');
    close.addEventListener('click', removeModal);

    const body = document.createElement('div');
    body.innerHTML = html;

    panel.appendChild(close);
    panel.appendChild(body);
    overlay.appendChild(panel);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) removeModal();
    });

    return overlay;
  }

  function removeModal() {
    const el = document.getElementById('dz-policy-overlay');
    if (el) el.remove();
  }

  function interceptPolicyLinks() {
    document.addEventListener('click', function (e) {
      const link = e.target.closest('.tax-note a');
      if (!link) return;
      e.preventDefault();

      const href = link.getAttribute('href');
      if (!href) return;

      fetch(href)
        .then(r => r.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const content =
            doc.querySelector('.policy__body') ||
            doc.querySelector('[class*="policy"]') ||
            doc.querySelector('main') ||
            doc.body;

          const modal = buildModal(content ? content.innerHTML : '<p>Unable to load policy.</p>');
          document.body.appendChild(modal);
        })
        .catch(() => {
          const modal = buildModal('<p>Unable to load the shipping policy. Please visit the page directly.</p>');
          document.body.appendChild(modal);
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', interceptPolicyLinks);
  } else {
    interceptPolicyLinks();
  }
})();

/* ── Drawer wholesale discount % ──
   The WPD app injects "<s>retail</s> wholesale" into .dz-p-val--ws. Compute the discount %
   from the app's wholesale price + the server retail (.dz-strike-val) and fill .dz-p-pct,
   matching the main-cart mobile format. Re-syncs via MutationObserver (the app updates async). */
(function () {
  function money(s) { return s ? parseFloat(String(s).replace(/[^0-9.]/g, '')) : NaN; }
  function syncPct(li) {
    if (!li) return;
    var val = li.querySelector('.dz-p-val--ws');
    var retailEl = li.querySelector('.dz-strike-val');
    var pctEl = li.querySelector('.dz-p-pct');
    if (!val || !retailEl || !pctEl) return;
    var clone = val.cloneNode(true);
    var s = clone.querySelector('s'); if (s) { s.remove(); }   // drop the app's struck retail, keep the wholesale price
    var ws = money(clone.textContent);
    var retail = money(retailEl.textContent);
    var out = (ws > 0 && retail > ws) ? '-' + Math.round((retail - ws) / retail * 100) + '%' : '';
    if (pctEl.textContent !== out) { pctEl.textContent = out; }
  }
  function syncAll() { document.querySelectorAll('.mini-cart__navigation > li').forEach(syncPct); }
  function wire() {
    if (!window.MutationObserver) { syncAll(); return; }
    document.querySelectorAll('.mini-cart__navigation .dz-p-val--ws').forEach(function (v) {
      if (v.__dzPctObs) { return; }
      v.__dzPctObs = new MutationObserver(function () { syncPct(v.closest('li')); });
      v.__dzPctObs.observe(v, { childList: true, subtree: true, characterData: true });
    });
    syncAll();
  }
  document.addEventListener('cartdrawer:opened', function () { [50, 600, 1500].forEach(function (t) { setTimeout(wire, t); }); });
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { setTimeout(wire, 300); }); }
  else { setTimeout(wire, 300); }
})();

/* ── Drawer "Save for later" — push to the SAME `dz-cart-saved` localStorage, then
   remove the line via AJAX and re-render the drawer IN PLACE (no redirect to /cart).
   The item surfaces in the main cart's "Saved for later" section. ── */
(function () {
  var LS_SAVED = 'dz-cart-saved';
  function readSaved() { try { return JSON.parse(localStorage.getItem(LS_SAVED) || '[]'); } catch (e) { return []; } }
  function writeSaved(arr) { try { localStorage.setItem(LS_SAVED, JSON.stringify(arr)); } catch (e) {} }
  // `item.properties | json` renders as [[key,value],...] with HTML-entity-encoded values;
  // normalize to a plain {key:value} object with real characters so /cart/add.js accepts it.
  function decodeEntities(s) {
    if (typeof s !== 'string' || s.indexOf('&') === -1) return s;
    var d = document.createElement('textarea'); d.innerHTML = s; return d.value;
  }
  function parseProps(raw) {
    if (!raw) return {};
    var v; try { v = JSON.parse(raw); } catch (e) { return {}; }
    var obj = {};
    if (Array.isArray(v)) {
      v.forEach(function (p) { if (Array.isArray(p) && p.length >= 2) obj[decodeEntities(String(p[0]))] = decodeEntities(p[1]); });
    } else if (v && typeof v === 'object') {
      Object.keys(v).forEach(function (k) { obj[decodeEntities(k)] = decodeEntities(v[k]); });
    }
    return obj;
  }
  function sectionInner(html) {
    try { var s = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section'); return s ? s.innerHTML : html; }
    catch (e) { return html; }
  }
  document.addEventListener('click', function (e) {
    var save = e.target.closest && e.target.closest('.dz-drawer-save');
    if (!save) return;
    e.preventDefault();
    var saved = readSaved();
    var vid = parseInt(save.getAttribute('data-variant-id'), 10);
    var props = parseProps(save.getAttribute('data-properties'));
    var sp = parseInt(save.getAttribute('data-selling-plan'), 10) || null;
    var pkey = JSON.stringify(props);
    if (vid && !saved.some(function (s) { return s.variantId === vid && JSON.stringify(s.properties || {}) === pkey; })) {
      saved.push({
        variantId: vid,
        qty: parseInt(save.getAttribute('data-qty'), 10) || 1,
        handle: save.getAttribute('data-handle'),
        title: save.getAttribute('data-title'),
        details: save.getAttribute('data-details') || '',
        properties: props,
        sellingPlan: sp,
        image: save.getAttribute('data-image') || '',
        price: save.getAttribute('data-price') || '',
        url: save.getAttribute('data-url') || ''
      });
      writeSaved(saved);
    }
    var key = save.getAttribute('data-key');
    var removeUrl = save.getAttribute('data-remove-url');
    if (!key) { if (removeUrl) window.location.href = removeUrl; return; }  // fallback
    var li = save.closest('li'); if (li) li.style.opacity = '0.4';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0, sections: ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        var secs = state && state.sections;
        if (!secs) { window.location.href = removeUrl || '/cart'; return; }
        var mc = document.getElementById('mini-cart');
        if (mc && secs['mini-cart']) { mc.innerHTML = sectionInner(secs['mini-cart']); document.dispatchEvent(new CustomEvent('cartdrawer:opened')); }
        ['cart-icon-bubble', 'mobile-cart-icon-bubble'].forEach(function (id) {
          var el = document.getElementById(id);
          if (el && secs[id]) el.innerHTML = sectionInner(secs[id]);
        });
      })
      .catch(function () { window.location.href = removeUrl || '/cart'; });  // fallback on error
  });
})();

/* ── Press-and-hold the qty +/- to ramp the quantity (main cart + drawer).
   Loaded globally via the header, so it covers every `.quantity__button` once.
   Hold floors at 1 (never auto-deletes); a single 'change' fires on release so the
   cart updates just once. A quick tap is untouched (the native click still steps). ── */
(function () {
  if (window.__dzQtyHold) return; window.__dzQtyHold = true;
  var START = 350, MIN = 60, holdT = null, repT = null, input = null, dir = 0, ivl = START, didRepeat = false;
  function step() {
    var v = parseInt(input.value, 10); if (isNaN(v)) v = 0;
    var nv = v + dir; if (nv < 1) nv = 1;
    if (nv !== v) { input.value = nv; input.dispatchEvent(new Event('input', { bubbles: true })); }
  }
  function repeat() { if (!input) return; didRepeat = true; step(); ivl = Math.max(MIN, ivl * 0.84); repT = setTimeout(repeat, ivl); }
  function stop() {
    if (holdT) { clearTimeout(holdT); holdT = null; }
    if (repT) { clearTimeout(repT); repT = null; }
    if (didRepeat && input) input.dispatchEvent(new Event('change', { bubbles: true }));  // one cart update
    input = null; dir = 0; ivl = START;
  }
  document.addEventListener('pointerdown', function (e) {
    var btn = e.target.closest && e.target.closest('.quantity__button');
    if (!btn || btn.disabled) return;
    var d = btn.name === 'plus' ? 1 : -1;
    var qty = btn.closest('.quantity, quantity-input, gift-quantity');
    var inp = qty && qty.querySelector('.quantity__input');
    if (!inp) return;
    if (d === -1 && qty.classList && qty.classList.contains('dz-qty-removable')) return; // let trash-at-1 delete normally
    input = inp; dir = d; ivl = START; didRepeat = false;
    holdT = setTimeout(repeat, START);
  });
  ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
    document.addEventListener(ev, function () { if (holdT || repT) stop(); });
  });
  // swallow the click that follows a hold so the component doesn't add one extra step
  document.addEventListener('click', function (e) {
    if (!didRepeat) return;
    var btn = e.target.closest && e.target.closest('.quantity__button');
    if (btn) { e.preventDefault(); e.stopPropagation(); }
    didRepeat = false;
  }, true);
})();

/* ── Open the drawer anchored at the TOP of the product list.
   A logged-in wholesaler with many items + persistent-cart re-render + the drawer's
   focus-inset scroll were beating a single reset, so we BURST resets across ~1s so the
   last one wins after any late re-render/focus. ── */
(function () {
  // The drawer content is LAZY-LOADED (~1s after open), so a fixed 0–900ms burst fires before
  // the list exists. Instead we GUARD: keep pinning the scroll container to the top on every
  // mutation (lazy-load, WPD re-render) for a window after open — until the user actually scrolls.
  var guardUntil = 0, userScrolled = false;
  function scrollHost() { return document.querySelector('.mini-cart__main'); }
  function resetScroll() {
    if (userScrolled) return;
    var m = scrollHost(); if (m && m.scrollTop) m.scrollTop = 0;
    var nav = document.querySelector('.mini-cart__navigation'); if (nav && nav.scrollTop) nav.scrollTop = 0;
  }
  function beginGuard() {
    userScrolled = false;
    guardUntil = (window.performance ? performance.now() : Date.now()) + 2600;
    [0, 60, 140, 260, 420, 650, 900, 1200, 1600, 2000, 2600].forEach(function (t) { setTimeout(resetScroll, t); });
    if (window.requestAnimationFrame) requestAnimationFrame(resetScroll);
    var host = document.querySelector('.mini-cart');
    if (host && !host.__dzFillObs) {
      host.__dzFillObs = new MutationObserver(function () {
        var now = window.performance ? performance.now() : Date.now();
        if (now < guardUntil) resetScroll();
      });
      host.__dzFillObs.observe(host, { childList: true, subtree: true });
    }
  }
  // once the user scrolls/interacts inside the list, stop fighting them
  ['wheel', 'touchmove', 'keydown'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var m = scrollHost();
      if (m && e.target && m.contains(e.target)) userScrolled = true;
    }, { passive: true, capture: true });
  });
  function wire() {
    var details = document.querySelector('cart-drawer details');
    if (details && !details.__dzScrollObs) {
      details.__dzScrollObs = new MutationObserver(function () { if (details.hasAttribute('open')) beginGuard(); });
      details.__dzScrollObs.observe(details, { attributes: true, attributeFilter: ['open'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire);
  else wire();
  document.addEventListener('cartdrawer:opened', function () { wire(); beginGuard(); });
  // also catch the raw cart-icon click (covers any open path the observer misses)
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[href="#cart"], .header__icon--cart, cart-drawer summary, #cart-icon-bubble, #mobile-cart-icon-bubble')) beginGuard();
  }, true);

  /* ── C1: tap anywhere outside the drawer closes it ── */
  document.addEventListener('click', function (e) {
    var details = document.querySelector('cart-drawer details');
    if (!details || !details.hasAttribute('open')) return;
    // ignore clicks inside the drawer OR on the opener (the opening click bubbles here too)
    if (e.target.closest && e.target.closest('.mini-cart__inner, [href="#cart"], .header__icon--cart, cart-drawer summary, #cart-icon-bubble, #mobile-cart-icon-bubble')) return;
    var closeBtn = document.querySelector('cart-drawer drawer-close-button');
    if (closeBtn) { closeBtn.click(); return; }
    var sum = document.querySelector('cart-drawer summary');
    if (sum) { sum.click(); return; }
    details.removeAttribute('open');
  });
})();

/* ── Drawer TOTAL formatting: small currency code to the right + superscript cents.
   The subtotal (#mini-cart-subtotal) is raw money (guest) or WPD-injected
   "<s>retail</s>wholesale" (wholesale). Re-format idempotently; keep the struck retail
   untouched; disconnect the observer during our own write so we never loop. ── */
(function () {
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  function fmt(el, obs) {
    if (!el) return;
    var sEl = el.querySelector('s');
    var struckHTML = sEl ? sEl.outerHTML : '';
    var clone = el.cloneNode(true);
    var cs = clone.querySelector('s'); if (cs) cs.remove();
    var cur = clone.querySelector('.dz-cur'); if (cur) cur.remove();
    var wsc = clone.querySelector('.dz-total-ws'); if (wsc) wsc.remove();   // strip our own WS label before re-parsing
    var visible = clone.textContent.replace(/USD/g, '').replace(/\s+/g, ' ').trim();   // e.g. "$498.10"
    if (!/\d/.test(visible)) return;
    var m = visible.match(/^([\s\S]*?)(\.(\d{2}))\s*$/);   // dollars + .cents
    var amtHTML = m
      ? '<span class="dz-total-amt">' + m[1] + '<sup class="dz-total-cents">.' + m[3] + '</sup></span>'
      : '<span class="dz-total-amt">' + visible + '</span>';
    // "WS" sits right before the wholesale amount (only when the app injected a struck retail)
    var wsHTML = struckHTML ? '<span class="dz-total-ws">WS</span>' : '';
    var newInner = struckHTML + wsHTML + amtHTML + '<span class="dz-cur">' + CUR + '</span>';
    if (el.innerHTML.replace(/\s+/g, ' ').trim() === newInner.replace(/\s+/g, ' ').trim()) return;
    if (obs) obs.disconnect();
    el.innerHTML = newInner;
    if (obs) obs.observe(el, { childList: true, subtree: true, characterData: true });
  }
  function wire() {
    var el = document.getElementById('mini-cart-subtotal');
    if (!el || !el.classList.contains('dz-footer-cta__subtotal') || el.__dzTotalObs) return;
    var obs = new MutationObserver(function () { fmt(el, obs); });
    el.__dzTotalObs = obs;
    obs.observe(el, { childList: true, subtree: true, characterData: true });
    [50, 400, 1200].forEach(function (t) { setTimeout(function () { fmt(el, obs); }, t); });
  }
  document.addEventListener('cartdrawer:opened', function () { [50, 600, 1500].forEach(function (t) { setTimeout(wire, t); }); });
  if (document.readyState !== 'loading') setTimeout(wire, 300);
})();

/* ── C4: trash icon on the minus at qty 1 in the drawer (mirrors the main cart) ── */
(function () {
  function syncDrawerTrash() {
    document.querySelectorAll('.mini-cart .dz-item-bot .quantity').forEach(function (q) {
      var input = q.querySelector('.quantity__input');
      if (!input) return;
      q.classList.toggle('dz-qty-removable', parseInt(input.value, 10) <= 1);
    });
  }
  document.addEventListener('input', function (e) {
    if (e.target.closest && e.target.closest('.mini-cart .dz-item-bot .quantity')) syncDrawerTrash();
  });
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.mini-cart .dz-item-bot .quantity')) syncDrawerTrash();
  });
  // minus at qty 1 removes the line via the existing cart-remove-button (AJAX + re-render, stays in the drawer)
  document.addEventListener('click', function (e) {
    var minus = e.target.closest && e.target.closest('.mini-cart .dz-drawer-minus');
    if (!minus) return;
    var q = minus.closest('.quantity');
    if (!q || !q.classList.contains('dz-qty-removable')) return;
    e.preventDefault(); e.stopPropagation();
    var bot = minus.closest('.dz-item-bot');
    var rm = bot && bot.querySelector('cart-remove-button');
    if (rm) { (rm.querySelector('a, button') || rm).click(); return; }
    var url = minus.getAttribute('data-remove-url');
    if (url) window.location.href = url;
  }, true);
  document.addEventListener('cartdrawer:opened', function () { [200, 800, 1600].forEach(function (t) { setTimeout(syncDrawerTrash, t); }); });
  if (document.readyState !== 'loading') setTimeout(syncDrawerTrash, 500);
  else document.addEventListener('DOMContentLoaded', function () { setTimeout(syncDrawerTrash, 500); });
})();

/* ── E2: drawer "View saved for later" button reflects the shared saved-for-later count ── */
(function () {
  function updateSavedLink() {
    var link = document.querySelector('[data-dz-saved-link]');
    if (!link) return;
    var count = 0;
    try { count = (JSON.parse(localStorage.getItem('dz-cart-saved') || '[]') || []).length; } catch (e) {}
    var txt = link.querySelector('.dz-drawer-saved-link__text');
    if (count > 0) {
      link.classList.remove('dz-drawer-saved-link--empty');
      link.setAttribute('href', link.getAttribute('data-href') || '/cart#dz-saved-section');
      if (txt) txt.textContent = 'View saved for later (' + count + ')';
    } else {
      link.classList.add('dz-drawer-saved-link--empty');
      link.removeAttribute('href');
      if (txt) txt.textContent = 'No items saved yet';
    }
  }
  document.addEventListener('cartdrawer:opened', function () { [100, 600, 1400].forEach(function (t) { setTimeout(updateSavedLink, t); }); });
  if (document.readyState !== 'loading') setTimeout(updateSavedLink, 400);
  else document.addEventListener('DOMContentLoaded', function () { setTimeout(updateSavedLink, 400); });
})();
